import React from 'react'
import {IconButton} from '../../common/base/buttons'
import {TablerIcons} from '../../common/icon-tabler/icon-tabler'

interface BorderedIconButtonProps {
  icon: TablerIcons
  onClick: () => void
}

export const BorderedIconButton = (props: BorderedIconButtonProps) => {
  const {icon, onClick} = props
  return (
    <div className="border-1 border-solid border-border-base rounded-6">
      <IconButton
        icon={icon}
        className="max-h-18 max-w-18"
        size="medium"
        color="secondary"
        onClick={onClick}
      />
    </div>
  )
}
